import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { UpdateInvoiceForwardingSettingsPayload } from './types';

import { apiResourceSchema } from '../common/schemas';
import { QueryKeys } from '../keys';
import { request } from '../request';
import { userSchema } from './schemas';
import { userQueryOptions } from './useUser';

export const useUpdateInvoiceForwardingSettings = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: UpdateInvoiceForwardingSettingsPayload) => {
      const response = await request('/user/invoice-forwarding-settings', { method: 'PUT', body });

      const { data: user } = apiResourceSchema(userSchema).parse(response);

      return user;
    },
    onSuccess: (user) => {
      queryClient.setQueryData(userQueryOptions.queryKey, () => user);
      queryClient.invalidateQueries({ queryKey: QueryKeys.user });
    },
  });
};
